// extracted by mini-css-extract-plugin
module.exports = {"histogram":"AFfCN5Q","chartHeader":"_1T_DQdF _3CUZFzn _1LFpV2n","chartContainer":"_3MTEx78","svg":"_1nl04q7","column":"_1_3SzgT","tickLine":"_1HD-B4o","tick":"_3OOsByG"};